import { z } from 'zod';
import { jArticleLittleSchema } from './article';
import { jUserListSchema } from './user';
import { objectListPropsSchema } from './utils';

export const adminLicenseStatsSchema = z.object({
    countActiveUsersWithoutLicense: z.number().optional(),
    countLicensesAssigned: z.number(),
    countLicensesNotAssigned: z.number(),
});
export type AdminLicenseStats = z.infer<typeof adminLicenseStatsSchema>;

export const objectWithoutLicenseFilterSchema = z.object({
    name: z.string(),
    operator: z.string(),
    value: z.number(),
});
export type ObjectWithoutLicenseFilter = z.infer<typeof objectWithoutLicenseFilterSchema>;

export const adminLicensesNotAssignedSchema = z.record(z.number());
export type AdminLicensesNotAssigned = z.infer<typeof adminLicensesNotAssignedSchema>;

export const adminLicensesAssignedSchema = z.object({
    id: z.number(),
    kind: z.string(),
    dateCreation: z.string(),
    idFeature: z.number(),
    uri: z.string(),
    contentId: z.number(),
    contentType: z.string(),
    status: z.number(),
});
export type AdminLicensesAssigned = z.infer<typeof adminLicensesAssignedSchema>;

export const licenseSchema = z.object({
    id: z.number(),
    kind: z.string(),
    dateCreation: z.string(),
    idFeature: z.number(),
    uri: z.string(),
    contentId: z.number(),
    contentType: z.string(),
    status: z.number(),
});
export type License = z.infer<typeof licenseSchema>;

export const jAdminLicenseUserListSchema = jUserListSchema.extend({
    _extend: z.object({
        licenses: z.array(licenseSchema),
    }),
});

export type JAdminLicenseUserList = z.infer<typeof jAdminLicenseUserListSchema>;

export const adminLicenseUserSchema = objectListPropsSchema.extend({
    data: jAdminLicenseUserListSchema.array(),
});
export type AdminLicenseUser = z.infer<typeof adminLicenseUserSchema>;

export const jAdminLicenseArticleListSchema = jArticleLittleSchema.extend({
    _extend: z.object({
        licenses: z.array(licenseSchema),
        active: z.boolean(),
        month_requests_max: z.number(),
        month_requests_hit: z.number(),
    }),
});
export type JAdminLicenseArticleList = z.infer<typeof jAdminLicenseArticleListSchema>;

export const adminLicenseArticleListSchema = objectListPropsSchema.extend({
    data: jAdminLicenseArticleListSchema.array(),
});
export type AdminLicenseArticleList = z.infer<typeof adminLicenseArticleListSchema>;
